/* eslint-disable radix */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-nested-ternary */
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import useMessageDispatcher from 'hooks/useMessageDispatcher';
import {
    Box,
    Button,
    Chip,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Paper,
    Switch,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { FieldArray } from 'formik';
import { CloudUpload } from '@mui/icons-material';

const header = {
    headers: {
        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
        'Content-Type': 'application/json'
    }
};
const headerStyle = {
    textAlign: 'center',
    color: '#005e9f',
    fontWeight: 600,
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 1
};
const textBoxStyle = { width: '80px' };
const cellStyle = { textAlign: 'center' };

const SemesterStudentListForBAMS = ({ values, setFieldValue, handleSearch }) => {
    const showMessage = useMessageDispatcher();
    const filteredSubject = values?.courseList?.find((item) => item?.id === values?.selectedSubjectDetail);
    const internalAssessments = values?.internalAssessments;
    const [totalofall, settotalofall] = useState(0);
    const [totalofmarks, settotalofmarks] = useState([]);

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loadingUpload, setLoadingUpload] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const submitMarksHandler = async (marks, index, studentId, type) => {
        const { studentExamRecord } = values.semesterStudentData[index];
        const { descriptiveMarks, objectiveMarks, practicalMarks, vivaMarks, electiveMarks } = studentExamRecord;
        const iaMarks = isNaN(values.semesterStudentData[index]?.marks[values.semesterStudentData[index].marks?.length - 1])
            ? 0
            : values.semesterStudentData[index]?.marks[values.semesterStudentData[index].marks?.length - 1];

        const descriptive = type === 'descriptive' ? marks : isNaN(descriptiveMarks) ? 0 : descriptiveMarks;
        const objective = type === 'objective' ? marks : isNaN(objectiveMarks) ? 0 : objectiveMarks;
        const practical = type === 'practical' ? marks : isNaN(practicalMarks) ? 0 : practicalMarks;
        const viva = type === 'viva' ? marks : isNaN(vivaMarks) ? 0 : vivaMarks;
        const elective = type === 'elective' ? marks : isNaN(electiveMarks) ? 0 : electiveMarks;
        const marksScored = Number(descriptive) + Number(objective) + Number(practical) + Number(viva) + Number(elective) + Number(iaMarks);
        const theoryMark = objective + descriptive + elective;
        const theory = type === 'theory' ? marks : isNaN(theoryMark) ? 0 : theoryMark;
        const shallowTotalMarksArray = totalofmarks;
        shallowTotalMarksArray[index] = theoryMark;
        settotalofmarks([]);
        settotalofmarks(shallowTotalMarksArray);
        const shallowStudentExamRecord = values.semesterStudentData[index].studentExamRecord;
        shallowStudentExamRecord.descriptiveMarks = descriptive;
        shallowStudentExamRecord.objectiveMarks = objective;
        shallowStudentExamRecord.practicalMarks = practical;
        shallowStudentExamRecord.theoryMarks = theory;
        shallowStudentExamRecord.vivaMarks = viva;
        shallowStudentExamRecord.electiveMarks = elective;

        const shallowSemesterStudentData = values.semesterStudentData;
        shallowSemesterStudentData[index].studentExamRecord = shallowStudentExamRecord;

        try {
            const response = await axios.post(
                `/v1/exams/marks/entry?subjectDetailId=${values?.selectedSubjectDetail}&examGroupId=${
                    values?.examId
                }&studentId=${studentId}&marksScored=${marksScored}&descriptiveMarks=${descriptive}&objectiveMarks=${objective}&theoryMarks=${
                    filteredSubject?.subjectMini?.lab ? 0 : theory
                }&practicalMarks=${!filteredSubject?.subjectMini?.lab ? 0 : practical}&vivaMarks=${viva}&electiveMarks=${elective}`,
                {},
                header
            );
            if (response.status === 200) {
                setFieldValue('semesterStudentData', shallowSemesterStudentData);
                showMessage({ message: response?.data?.Msg, color: 'success' });
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const handleAttendance = async (row, status, type) => {
        try {
            const params = new URLSearchParams();
            params.append('studentExamRecordId', row?.studentExamRecord?.id);

            if (type === 'viva' || row.vivaAttended !== null) {
                params.append('vivaAttendance', type === 'viva' ? status : row.vivaAttended);
            }

            if (type === 'practical' || row.practicalAttended !== null) {
                params.append('practicalAttendance', type === 'practical' ? status : row.practicalAttended);
            }
            const response = await axios.put(`/v1/exams/mark-attendance?studentExamRecordId=${row?.studentExamRecord?.id}`, {}, header);
            if (response.status === 200) {
                if (response.data.code !== '403') {
                    showMessage({ message: response?.data?.data, color: 'success' });
                }
            }
        } catch (error) {
            if (!error.response) {
                showMessage({ message: error.message, color: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, color: 'error' });
            }
        }
    };
    const safeSum = (arr) => arr.reduce((sum, val) => sum + (isNaN(parseFloat(val)) ? 0 : parseFloat(val)), 0);

    const handleOpenDialog = (subject) => {
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setSelectedFile(null);
        setOpenDialog(false);
    };

    const onDownload = (downloadLink) => {
        const link = document.createElement('a');
        link.download = downloadLink;
        link.target = '_blank';
        link.href = downloadLink;
        link.click();
    };
    const handleDownloadExcel = async () => {
        setLoadingDownload(true);
        try {
            const response = await axios.get(
                `/v1/internal/assessment/get/excell-sheet-for-sem?subjectDetailId=${values?.selectedSubjectDetail}&courseDetailId=${values?.selectedProgram?.id}&examGroupId=${values?.examId}`,
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const presignedUrl = response.data?.data;

            if (presignedUrl) {
                onDownload(presignedUrl);
            } else {
                alert('Failed to get download link.');
            }
        } catch (error) {
            alert('Error downloading Excel file.');
        } finally {
            setLoadingDownload(false);
        }
    };

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setSelectedFile(e.target.files[0]);
        }
    };

    const handleUploadExcel = async () => {
        if (!selectedFile) {
            alert('Please select an Excel file to upload.');
            setSelectedFile(null);
            return;
        }

        const formData = new FormData();
        formData.append('file', selectedFile);
        formData.append('subjectDetailId', values?.selectedSubjectDetail);
        formData.append('courseDetailId', values?.selectedProgram?.id);
        formData.append('examGroupId', values?.examId);
        setLoadingUpload(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/v1/internal/assessment/upload-excel/for-sem`, {
                method: 'POST',
                body: formData,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`
                }
            });
            const result = await response.json();
            if (response.ok) {
                handleSearch(values);
                setLoadingUpload(false);
                handleCloseDialog(false);
                setSelectedFile(null);
                showMessage({ message: result?.Msg || 'File uploaded successfully!', type: 'success' });
            } else {
                showMessage({ message: result?.Msg || 'Something went wrong!', type: 'error' });
            }
        } catch (error) {
            setSelectedFile(null);
            if (!error.response) {
                showMessage({ message: error.message, type: 'error' });
            } else {
                showMessage({ message: error.response.data.Msg, type: 'error' });
            }
            setLoadingUpload(false);
        } finally {
            setLoadingUpload(false);
        }
    };
    // const fetchBAMSStudents = async (examId, courseId, subjectId, studentId) => {
    //     try {
    //         setIsLoading(true);
    //         const response = await axios.get(
    //             `/v1/internal/assessment/get/for-previous?examGroupId=${examId}&courseDetailId=${courseId}&subjectDetailId=${subjectId}&studentId=${studentId}`,
    //             header
    //         );
    //         if (response.status === 200) {
    //             setIsLoading(false);
    //             if (response.data.code !== '403') {
    //                 setFieldValue('semesterStudentData', response?.data?.data?.studentMarksList);
    //                 setFieldValue('internalAssessments', response?.data?.data?.internalAssessments);
    //             }
    //         }
    //     } catch (error) {
    //         setIsLoading(false);
    //         setFieldValue('semesterStudentData', []);
    //         setFieldValue('internalAssessments', []);
    //         if (!error.response) {
    //             showMessage({ message: error.message, color: 'error' });
    //         } else {
    //             showMessage({ message: error.response.data.Msg, color: 'error' });
    //         }
    //     }
    // };
    useEffect(() => {
        const totalMarksArray = Array(values?.semesterStudentData?.length).fill(0);
        values?.semesterStudentData?.forEach((row, index) => {
            const objectiveMarksValue = parseFloat(row?.studentExamRecord?.objectiveMarks) || 0;
            const descriptiveMarksValue = parseFloat(row?.studentExamRecord?.descriptiveMarks) || 0;
            settotalofall(
                safeSum([
                    values?.semesterStudentData?.[values?.semesterStudentData?.length - 1]?.total,
                    filteredSubject?.subjectMini?.theoryMarks,
                    filteredSubject?.subjectMini?.practicalMarks,
                    filteredSubject?.subjectMini?.vivaMarks,
                    filteredSubject?.subjectMini?.electiveMarks
                ])
            );
            totalMarksArray[index] = objectiveMarksValue + descriptiveMarksValue;
        });

        settotalofmarks(totalMarksArray);
    }, [values?.semesterStudentData, filteredSubject]);
    return (
        <TableContainer component={Paper}>
            <Typography sx={{ fontSize: '16px', fontWeight: 'bold' }}>
                <span style={{ fontWeight: 'bold' }}>Total Marks : </span>
                {/* <span>{totalofall}</span> */}
                <span>{filteredSubject?.subjectMini?.totalMarks}</span>
            </Typography>

            <Grid container alignItems="center" justifyContent="space-between" sx={{ mt: 2 }}>
                <Grid item>
                    <Button variant="contained" color="secondary" sx={{ mr: 1 }} onClick={handleDownloadExcel} disabled={loadingDownload}>
                        {loadingDownload ? <CircularProgress size={24} color="inherit" /> : 'Download Excel'}
                    </Button>

                    <Button variant="contained" color="primary" startIcon={<CloudUpload />} onClick={() => handleOpenDialog()}>
                        Upload Marks
                    </Button>
                </Grid>
            </Grid>
            <div style={{ height: '75vh', overflowY: 'auto' }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell style={headerStyle}>Sl.No.</TableCell>

                            <TableCell style={headerStyle}>Student Details</TableCell>
                            {filteredSubject?.subjectMini?.lab ? (
                                <>
                                    <TableCell style={headerStyle}>Viva Attendance</TableCell>
                                    <TableCell style={headerStyle}>Practical Attendance</TableCell>
                                </>
                            ) : (
                                <TableCell style={headerStyle}> Attendance</TableCell>
                            )}
                            {filteredSubject?.subjectMini?.lab &&
                                internalAssessments?.map((assessment, index) => (
                                    <TableCell key={index} style={headerStyle}>
                                        {assessment}({index === internalAssessments.length - 1 ? 'Out of:' : 'Max:'}
                                        {values.semesterStudentData[0].total[index]})
                                    </TableCell>
                                ))}
                            {filteredSubject?.subjectMarks !== null && (
                                <>
                                    <TableCell style={headerStyle}>
                                        Objective Marks (Max:{filteredSubject?.subjectMarks?.objectiveMarks})
                                    </TableCell>
                                    <TableCell style={headerStyle}>
                                        Descriptive Marks (Max:{filteredSubject?.subjectMarks?.subjectiveMarks})
                                    </TableCell>
                                </>
                            )}
                            {filteredSubject?.subjectMini ? (
                                filteredSubject?.subjectMini?.labAndTheory ? (
                                    <>
                                        <TableCell style={headerStyle}>
                                            Theory Marks (Max:{filteredSubject?.subjectMini?.theoryMarks})
                                        </TableCell>
                                        {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                            <TableCell style={headerStyle}>
                                                Practical Marks (Max:{filteredSubject?.subjectMini?.practicalMarks})
                                            </TableCell>
                                        )}

                                        {filteredSubject?.subjectMini?.electiveMarks && (
                                            <TableCell style={headerStyle}>
                                                Elective Marks (Max:{filteredSubject?.subjectMini?.electiveMarks})
                                            </TableCell>
                                        )}
                                    </>
                                ) : filteredSubject?.subjectMini?.lab ? (
                                    <>
                                        {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                            <TableCell style={headerStyle}>
                                                Practical Marks (Max:{filteredSubject?.subjectMini?.practicalMarks})
                                            </TableCell>
                                        )}
                                        {filteredSubject?.subjectMini?.vivaMarks && (
                                            <TableCell style={headerStyle}>
                                                Viva Marks (Max:{filteredSubject?.subjectMini?.vivaMarks})
                                            </TableCell>
                                        )}
                                        {filteredSubject?.subjectMini?.electiveMarks && (
                                            <TableCell style={headerStyle}>
                                                Elective Marks (Max:{filteredSubject?.subjectMini?.electiveMarks})
                                            </TableCell>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <TableCell style={headerStyle}>
                                            Theory Marks (Max:{filteredSubject?.subjectMini?.theoryMarks})
                                        </TableCell>
                                        {filteredSubject?.subjectMini?.electiveMarks && (
                                            <TableCell style={headerStyle}>
                                                Elective Marks (Max:{filteredSubject?.subjectMini?.electiveMarks})
                                            </TableCell>
                                        )}
                                    </>
                                )
                            ) : null}

                            <TableCell style={headerStyle}>Total Obtained Marks</TableCell>
                        </TableRow>
                    </TableHead>
                    <FieldArray
                        name="semesterStudentData"
                        render={() => (
                            <TableBody>
                                {values?.semesterStudentData?.length > 0 &&
                                    values?.semesterStudentData
                                        ?.sort((a, b) => {
                                            const courseA = a?.studentExamRecord?.studentMini.rollNo?.split('/')[1];
                                            const courseB = b?.studentExamRecord?.studentMini.rollNo?.split('/')[1];

                                            if (courseA < courseB) return -1;
                                            if (courseA > courseB) return 1;

                                            const rollNoA = a?.studentExamRecord?.studentMini.rollNo?.split('/')[2];
                                            const rollNoB = b?.studentExamRecord?.studentMini.rollNo?.split('/')[2];
                                            return parseInt(rollNoA) - parseInt(rollNoB);
                                        })
                                        ?.map((row, index) => (
                                            <TableRow key={row.index}>
                                                <TableCell style={cellStyle} component="th">
                                                    {index + 1}
                                                </TableCell>
                                                <TableCell>
                                                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                        <Chip
                                                            label={row.studentExamRecord.attendedExam ? 'P' : 'A'}
                                                            size="small"
                                                            sx={{
                                                                color: 'black',
                                                                background: row.studentExamRecord.attendedExam ? '#00c853' : '#ff1744',
                                                                borderRadius: '50%',
                                                                marginRight: '8px'
                                                            }}
                                                            variant="outlined"
                                                        />
                                                        <Box>
                                                            <Typography
                                                                style={{
                                                                    fontWeight: 500,
                                                                    fontSize: '15px',
                                                                    color: '#333'
                                                                }}
                                                            >
                                                                {row.studentExamRecord?.studentMini?.studentName}
                                                            </Typography>
                                                            <Typography
                                                                variant="h6"
                                                                style={{
                                                                    fontWeight: 600,
                                                                    fontSize: '13px',
                                                                    color: '#757575'
                                                                }}
                                                            >
                                                                {row.studentExamRecord?.studentMini?.rollNo}
                                                            </Typography>
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                {filteredSubject?.subjectMini?.lab ? (
                                                    <>
                                                        <TableCell style={cellStyle} component="th">
                                                            <Switch
                                                                defaultChecked={row.studentExamRecord?.attendedExam}
                                                                onChange={(event) => handleAttendance(row, event.target.checked, 'viva')}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={cellStyle} component="th">
                                                            <Switch
                                                                defaultChecked={row.studentExamRecord?.attendedExam}
                                                                onChange={(event) =>
                                                                    handleAttendance(row, event.target.checked, 'practical')
                                                                }
                                                            />
                                                        </TableCell>
                                                    </>
                                                ) : (
                                                    <TableCell style={cellStyle} component="th">
                                                        <Switch
                                                            defaultChecked={row.studentExamRecord?.attendedExam}
                                                            onChange={(event) => handleAttendance(row, event.target.checked, 'attendance')}
                                                        />
                                                    </TableCell>
                                                )}

                                                {filteredSubject?.subjectMini?.lab &&
                                                    row?.marks?.map((mark, index) => (
                                                        <TableCell key={index} style={cellStyle}>
                                                            {isNaN(parseFloat(mark)) ? 0 : Math.round(mark)}
                                                        </TableCell>
                                                    ))}

                                                {filteredSubject?.subjectMarks !== null && (
                                                    <>
                                                        <TableCell style={cellStyle}>
                                                            <TextField
                                                                onFocus={(e) => e.target.select()}
                                                                style={textBoxStyle}
                                                                name={`semesterStudentData.${index}.objectiveMarks`}
                                                                value={
                                                                    values.semesterStudentData[index]?.studentExamRecord?.objectiveMarks ||
                                                                    0
                                                                }
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const maxMarks = filteredSubject?.subjectMarks?.objectiveMarks || 0;
                                                                    if (!/^\d*$/.test(value)) return;
                                                                    const numericValue = value === '' ? '' : parseInt(value, 10);
                                                                    if (numericValue !== '' && numericValue <= maxMarks) {
                                                                        setFieldValue(
                                                                            `semesterStudentData.${index}.objectiveMarks`,
                                                                            numericValue
                                                                        );

                                                                        const { studentId } =
                                                                            values.semesterStudentData[index]?.studentExamRecord;
                                                                        submitMarksHandler(numericValue, index, studentId, 'objective');
                                                                    }
                                                                }}
                                                                disabled={!row.studentExamRecord.attendedExam}
                                                            />
                                                        </TableCell>
                                                        <TableCell style={cellStyle}>
                                                            <TextField
                                                                onFocus={(e) => e.target.select()}
                                                                style={textBoxStyle}
                                                                name={`semesterStudentData.${index}.descriptiveMarks`}
                                                                value={
                                                                    values.semesterStudentData[index]?.studentExamRecord
                                                                        ?.descriptiveMarks || 0
                                                                }
                                                                onChange={(event) => {
                                                                    const { value } = event.target;
                                                                    const maxMarks = filteredSubject?.subjectMarks?.subjectiveMarks || 0;
                                                                    if (!/^\d*$/.test(value)) return;
                                                                    const numericValue = value === '' ? '' : parseInt(value, 10);
                                                                    if (numericValue !== '' && numericValue <= maxMarks) {
                                                                        setFieldValue(
                                                                            `semesterStudentData.${index}.descriptiveMarks`,
                                                                            numericValue
                                                                        );

                                                                        const { studentId } =
                                                                            values.semesterStudentData[index]?.studentExamRecord;
                                                                        submitMarksHandler(numericValue, index, studentId, 'descriptive');
                                                                    }
                                                                }}
                                                                disabled={!row.studentExamRecord.attendedExam}
                                                            />
                                                        </TableCell>
                                                    </>
                                                )}

                                                {filteredSubject?.subjectMini ? (
                                                    filteredSubject?.subjectMini?.labAndTheory ? (
                                                        <>
                                                            <TableCell style={cellStyle}>
                                                                <TextField
                                                                    onFocus={(e) => e.target.select()}
                                                                    style={textBoxStyle}
                                                                    name={`semesterStudentData.${index}.theory`}
                                                                    disabled
                                                                    value={Math.round(totalofmarks[index]) || 0}
                                                                    onChange={(event) => {
                                                                        const { value } = event.target;
                                                                        const { studentId } =
                                                                            values.semesterStudentData[index]?.studentExamRecord;
                                                                        submitMarksHandler(value, index, studentId, 'theory');
                                                                    }}
                                                                />
                                                            </TableCell>

                                                            {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                                                <TableCell style={cellStyle}>
                                                                    <TextField
                                                                        onFocus={(e) => e.target.select()}
                                                                        style={textBoxStyle}
                                                                        name={`semesterStudentData.${index}.practical`}
                                                                        value={
                                                                            values.semesterStudentData[index]?.studentExamRecord
                                                                                ?.practicalMarks || 0
                                                                        }
                                                                        onChange={(event) => {
                                                                            const maxMarks =
                                                                                filteredSubject?.subjectMini?.practicalMarks || 0;
                                                                            const { value } = event.target;
                                                                            if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                                setFieldValue(
                                                                                    `semesterStudentData.${index}.practical`,
                                                                                    value
                                                                                );
                                                                                const { studentId } =
                                                                                    values.semesterStudentData[index]?.studentExamRecord;
                                                                                submitMarksHandler(value, index, studentId, 'practical');
                                                                            }
                                                                        }}
                                                                        disabled={!row.studentExamRecord.attendedExam}
                                                                    />
                                                                </TableCell>
                                                            )}
                                                            {filteredSubject?.subjectMini?.electiveMarks && (
                                                                <TableCell style={cellStyle}>
                                                                    <TextField
                                                                        onFocus={(e) => e.target.select()}
                                                                        style={textBoxStyle}
                                                                        name={`semesterStudentData.${index}.elective`}
                                                                        value={
                                                                            values.semesterStudentData[index]?.studentExamRecord
                                                                                ?.electiveMarks || 0
                                                                        }
                                                                        onChange={(event) => {
                                                                            const maxMarks =
                                                                                filteredSubject?.subjectMini?.electiveMarks || 0;
                                                                            const { value } = event.target;

                                                                            if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                                setFieldValue(
                                                                                    `semesterStudentData.${index}.elective`,
                                                                                    value
                                                                                );
                                                                                const { studentId } =
                                                                                    values.semesterStudentData[index]?.studentExamRecord;
                                                                                submitMarksHandler(value, index, studentId, 'elective');
                                                                            }
                                                                        }}
                                                                        disabled={!row.studentExamRecord.attendedExam}
                                                                    />
                                                                </TableCell>
                                                            )}
                                                        </>
                                                    ) : filteredSubject?.subjectMini?.lab ? (
                                                        <>
                                                            {filteredSubject?.subjectMini?.practicalMarks > 0 && (
                                                                <TableCell style={cellStyle}>
                                                                    <TextField
                                                                        onFocus={(e) => e.target.select()}
                                                                        style={textBoxStyle}
                                                                        name={`semesterStudentData.${index}.practical`}
                                                                        value={
                                                                            !row.studentExamRecord.practicalAttended
                                                                                ? 'AB'
                                                                                : values.semesterStudentData[index]?.studentExamRecord
                                                                                      ?.practicalMarks || 0
                                                                        }
                                                                        onChange={(event) => {
                                                                            const maxMarks =
                                                                                filteredSubject?.subjectMini?.practicalMarks || 0;
                                                                            const { value } = event.target;
                                                                            if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                                setFieldValue(
                                                                                    `semesterStudentData.${index}.practical`,
                                                                                    value
                                                                                );
                                                                                const { studentId } =
                                                                                    values.semesterStudentData[index]?.studentExamRecord;
                                                                                submitMarksHandler(value, index, studentId, 'practical');
                                                                            }
                                                                        }}
                                                                        disabled={!row.studentExamRecord.practicalAttended}
                                                                    />
                                                                </TableCell>
                                                            )}
                                                            {filteredSubject?.subjectMini?.vivaMarks && (
                                                                <TableCell style={cellStyle}>
                                                                    <TextField
                                                                        onFocus={(e) => e.target.select()}
                                                                        style={textBoxStyle}
                                                                        name={`semesterStudentData.${index}.vivaAttended`}
                                                                        value={
                                                                            !row.studentExamRecord.vivaAttended
                                                                                ? 'AB'
                                                                                : values.semesterStudentData[index]?.studentExamRecord
                                                                                      ?.vivaMarks || 0
                                                                        }
                                                                        onChange={(event) => {
                                                                            const maxMarks = filteredSubject?.subjectMini?.vivaMarks || 0;
                                                                            const { value } = event.target;
                                                                            if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                                setFieldValue(`semesterStudentData.${index}.viva`, value);
                                                                                const { studentId } =
                                                                                    values.semesterStudentData[index]?.studentExamRecord;
                                                                                submitMarksHandler(value, index, studentId, 'viva');
                                                                            }
                                                                        }}
                                                                        disabled={!row.studentExamRecord.vivaAttended}
                                                                    />
                                                                </TableCell>
                                                            )}

                                                            {filteredSubject?.subjectMini?.electiveMarks && (
                                                                <TableCell style={cellStyle}>
                                                                    <TextField
                                                                        onFocus={(e) => e.target.select()}
                                                                        style={textBoxStyle}
                                                                        name={`semesterStudentData.${index}.elective`}
                                                                        value={
                                                                            values.semesterStudentData[index]?.studentExamRecord
                                                                                ?.electiveMarks || 0
                                                                        }
                                                                        onChange={(event) => {
                                                                            const maxMarks =
                                                                                filteredSubject?.subjectMini?.electiveMarks || 0;
                                                                            const { value } = event.target;

                                                                            if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                                setFieldValue(
                                                                                    `semesterStudentData.${index}.elective`,
                                                                                    value
                                                                                );
                                                                                const { studentId } =
                                                                                    values.semesterStudentData[index]?.studentExamRecord;
                                                                                submitMarksHandler(value, index, studentId, 'elective');
                                                                            }
                                                                        }}
                                                                        disabled={
                                                                            !(
                                                                                row.studentExamRecord.vivaAttended ||
                                                                                row.studentExamRecord.practicalAttended
                                                                            )
                                                                        }
                                                                    />
                                                                </TableCell>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <TableCell style={cellStyle}>
                                                                {' '}
                                                                <TextField
                                                                    onFocus={(e) => e.target.select()}
                                                                    style={textBoxStyle}
                                                                    name={`semesterStudentData.${index}.theory`}
                                                                    disabled
                                                                    value={Math.round(totalofmarks[index]) || 0}
                                                                    onChange={(event) => {
                                                                        const { value } = event.target;
                                                                        const { studentId } =
                                                                            values.semesterStudentData[index]?.studentExamRecord;
                                                                        submitMarksHandler(value, index, studentId, 'theory');
                                                                    }}
                                                                />
                                                            </TableCell>
                                                            {filteredSubject?.subjectMini?.electiveMarks && (
                                                                <TableCell style={cellStyle}>
                                                                    <TextField
                                                                        onFocus={(e) => e.target.select()}
                                                                        style={textBoxStyle}
                                                                        name={`semesterStudentData.${index}.elective`}
                                                                        value={
                                                                            values.semesterStudentData[index]?.studentExamRecord
                                                                                ?.electiveMarks || 0
                                                                        }
                                                                        onChange={(event) => {
                                                                            const maxMarks =
                                                                                filteredSubject?.subjectMini?.electiveMarks || 0;
                                                                            const { value } = event.target;

                                                                            if (/^\d*$/.test(value) && Number(value) <= maxMarks) {
                                                                                setFieldValue(
                                                                                    `semesterStudentData.${index}.elective`,
                                                                                    value
                                                                                );
                                                                                const { studentId } =
                                                                                    values.semesterStudentData[index]?.studentExamRecord;
                                                                                submitMarksHandler(value, index, studentId, 'elective');
                                                                            }
                                                                        }}
                                                                        disabled={
                                                                            !(
                                                                                row.studentExamRecord.vivaAttended ||
                                                                                row.studentExamRecord.practicalAttended
                                                                            )
                                                                        }
                                                                    />
                                                                </TableCell>
                                                            )}
                                                        </>
                                                    )
                                                ) : null}
                                                <TableCell style={cellStyle}>
                                                    {Math.round(
                                                        safeSum([
                                                            row.marks[row.marks?.length - 1],
                                                            totalofmarks[index],
                                                            values?.semesterStudentData?.[index]?.studentExamRecord?.practicalMarks,
                                                            values?.semesterStudentData?.[index]?.studentExamRecord?.vivaMarks,
                                                            values?.semesterStudentData?.[index]?.studentExamRecord?.electiveMarks
                                                        ])
                                                    )}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                            </TableBody>
                        )}
                    />
                </Table>
            </div>

            <Dialog open={openDialog}>
                <DialogTitle>Upload Semester Marks</DialogTitle>
                <DialogContent>
                    {/* <Typography variant="h4" mb={1.5}></Typography> */}
                    <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} />
                    {selectedFile && (
                        <Typography variant="body2" color="primary">
                            Selected File: {selectedFile.name}
                        </Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="secondary">
                        Cancel
                    </Button>
                    <Button onClick={handleUploadExcel} color="primary" variant="contained" disabled={loadingUpload}>
                        {loadingUpload ? <CircularProgress size={24} color="error" /> : 'Upload'}
                    </Button>
                </DialogActions>
            </Dialog>
        </TableContainer>
    );
};

export default SemesterStudentListForBAMS;
